import { useCallback, useEffect, useState } from 'react';

const KEY = 'hg_theme';
const MODES = ['auto', 'light', 'dark'];

function applyTheme(mode) {
  const root = document.documentElement;
  root.classList.remove('light', 'dark');
  if (mode === 'light') {
    root.classList.add('light');
    return;
  }
  if (mode === 'dark') {
    root.classList.add('dark');
    return;
  }
  // auto = laisse le navigateur faire via prefers-color-scheme
  if (window.matchMedia('(prefers-color-scheme: light)').matches) {
    root.classList.add('light');
  }
}

export function useTheme() {
  const [theme, setThemeState] = useState(() => {
    const stored = localStorage.getItem(KEY);
    return MODES.includes(stored) ? stored : 'auto';
  });

  useEffect(() => {
    applyTheme(theme);
    localStorage.setItem(KEY, theme);
  }, [theme]);

  // Si l'utilisateur est en `auto`, on suit dynamiquement les changements OS.
  useEffect(() => {
    if (theme !== 'auto') return undefined;
    const mq = window.matchMedia('(prefers-color-scheme: light)');
    const handler = () => applyTheme('auto');
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [theme]);

  const setTheme = useCallback((mode) => {
    if (!MODES.includes(mode)) return;
    setThemeState(mode);
  }, []);

  const cycleTheme = useCallback(() => {
    setThemeState((prev) => {
      const idx = MODES.indexOf(prev);
      return MODES[(idx + 1) % MODES.length];
    });
  }, []);

  return { theme, setTheme, cycleTheme };
}
